import React, { Component, ReactNode, RefObject } from 'react';
import { View3dElement } from '@ikea-aoa/component-view-3d';
import { DeviceType, Platform } from 'sofa-reborn-react';
import { Div, DebugLayer } from './SceneStyle';
import '@ikea-aoa/component-view-3d';

type Props = {
	onSceneReady: (e: CustomEvent) => void;
	onModelsPreloaded: (e: CustomEvent) => void;
	onPointerOverNode: (e: CustomEvent) => void;
	onPointerOverGround: (e: CustomEvent) => void;
	onSceneResized?: (e: CustomEvent) => void;
	onCameraUpdated?: (e: CustomEvent) => void;
	hide?: boolean;
	showDebug?: boolean;
	deviceType: DeviceType;
	platform: Platform;
	sceneHeight: number;
};

const debugId = 'debugInfoId';

export default class Scene extends Component<Props> {
	private sceneRef: RefObject<View3dElement>;

	constructor(props: Readonly<Props>) {
		super(props);
		this.sceneRef = React.createRef<View3dElement>();
	}

	public componentDidMount = (): void => {
		if (this.sceneRef.current) {
			const view3d = this.sceneRef.current;
			view3d.addEventListener('sceneReady', this.onSceneReady);
			view3d.addEventListener('modelsPreloaded', this.props.onModelsPreloaded);
			view3d.addEventListener('onPointerOverNode', this.props.onPointerOverNode);
			view3d.addEventListener('onPointerOverGround', this.props.onPointerOverGround);
			if (this.props.onCameraUpdated) {
				view3d.addEventListener('onCameraUpdated', this.props.onCameraUpdated);
			}
			if (this.props.onSceneResized) {
				view3d.addEventListener('onSceneResized', this.props.onSceneResized);
			}
		}
	};

	public componentWillUnmount(): void {
		if (this.sceneRef.current) {
			const view3d = this.sceneRef.current;
			view3d.removeEventListener('sceneReady', this.props.onSceneReady);
			view3d.removeEventListener('modelsPreloaded', this.props.onModelsPreloaded);
			view3d.removeEventListener('onPointerOverNode', this.props.onPointerOverNode);
			view3d.removeEventListener('onPointerOverGround', this.props.onPointerOverGround);
			if (this.props.onCameraUpdated) {
				view3d.removeEventListener('onCameraUpdated', this.props.onCameraUpdated);
			}
			if (this.props.onSceneResized) {
				view3d.removeEventListener('onSceneResized', this.props.onSceneResized);
			}
		}
	}

	private onSceneReady = (e: CustomEvent): void => {
		this.props.onSceneReady(e);

		if (this.sceneRef && this.sceneRef.current) {
			if (this.props.showDebug) {
				this.sceneRef.current.showDebug(this.props.showDebug, debugId);
			}
		}
	};

	/**
	 * React render method.
	 *
	 * @returns React node.
	 */
	public render(): ReactNode {
		const { props } = this;
		return (
			<Div id="scene" platform={props.platform} show={!props.hide} sceneHeight={props.sceneHeight}>
				{props.showDebug ? <DebugLayer id={debugId} /> : null}
				<kompis-view-3d
					isMobile={props.deviceType === 'mobile' ? true : null}
					ref={this.sceneRef}
				></kompis-view-3d>
			</Div>
		);
	}
}
